/**
 * Ücretsiz kargo barem göstergesi — canlı güncelleme.
 * Sepet değiştiğinde (tema olayları veya /cart/*.js istekleri) /cart.js okunur ve
 * tüm [data-pg-fs] kutuları yeniden hesaplanır. Section yeniden render edilirse yeni HTML zaten günceldir.
 */
import { formatMoney } from '@theme/utilities';

if (!window.__pgFreeShipping) {
  window.__pgFreeShipping = true;

  let timer = null;
  let inflight = null;

  const render = (cart) => {
    document.querySelectorAll('[data-pg-fs]').forEach((box) => {
      const threshold = Number(box.dataset.threshold) || 0;
      if (!threshold) return;
      const total = Number(cart.total_price) || 0;
      const remaining = Math.max(0, threshold - total);
      const percent = Math.min(100, Math.floor((total * 100) / threshold));
      const done = remaining === 0;

      box.hidden = cart.item_count === 0;
      box.classList.toggle('is-done', done);

      const msg = box.querySelector('[data-pg-fs-msg]');
      if (msg) {
        msg.innerHTML = done
          ? box.dataset.msgDone
          : box.dataset.msgRemaining.replace("[amount]", formatMoney(remaining));
      }
      const bar = box.querySelector('[data-pg-fs-bar]');
      if (bar) {
        bar.setAttribute('aria-valuenow', String(percent));
        bar.querySelector('.pg-fs__fill')?.style.setProperty('--pg-fs-p', `${percent}%`);
      }
    });
  };

  const refresh = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(async () => {
      if (!document.querySelector('[data-pg-fs]')) return;
      try {
        inflight?.abort();
        inflight = new AbortController();
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' },
          signal: inflight.signal,
        });
        if (res.ok) render(await res.json());
      } catch (e) {
        if (e.name !== 'AbortError') console.warn('[pg-free-shipping]', e);
      }
    }, 250);
  };

  ['cart:update', 'cart:reload', 'cart:refresh', 'cart:count:update', 'cart:drawer:render', 'cart:main:render']
    .forEach((evt) => document.addEventListener(evt, refresh));

  // Tema dışı (uygulama vb.) sepet isteklerini de yakala
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const p = origFetch.apply(this, args);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) p.then(refresh, () => {});
    return p;
  };

  document.addEventListener('shopify:section:load', refresh);
}
